import { StillSize, ImageSize as imageType } from '#enums/imageSizes.ts';
import { SectionType } from '#enums/mediaTypes.ts';
import { buildImagePath } from '#helpers/buildImagePath.ts';
import { type Config } from '#types.ts';
import { type SeasonData, type TvSeasonEpisodeData } from '../types.ts';

export const formatEpisodes = (data: TvSeasonEpisodeData | null | undefined, { images }: Config): SeasonData[] =>
  data
    ? data.tv.seasons.map(({ episodes = [], seasonNumber, ...rest }) => {
        return {
          ...rest,
          episodes: episodes.map(({ episodeNumber, id, name, stillPath, ...other }) => {
            const subTitle = `Episode ${String(episodeNumber)}`;

            return {
              ...other,
              episodeNumber,
              id,
              src: buildImagePath(stillPath, imageType.Still, StillSize.LG, images),
              subTitle: subTitle === name ? '' : subTitle,
              title: name,
              type: SectionType.Episode,
              videoPathIds: [data.tv.id, seasonNumber, episodeNumber],
            };
          }),
          seasonNumber,
        };
      })
    : [];
